module.exports = __webpack_public_path__ + "static/media/kids-club.62cb3a73.png";